/**
 * // TODO перенести в чекаут
 */
import React from 'react';
import styled from 'styled-components';
import { Button } from '@lt/components';

import { i18n } from '@lt/localization';
import { Spinner } from 'src/components/animations/Spinner';

interface Props {
  isMobile: boolean;
  showPreloader: boolean;
  btnDisabled: boolean;
  children?: JSX.Element[] | JSX.Element;
  submit: () => void;
}
/**
 * Компонент футера для формы туристов
 * Содержит заголовок и кнопку далее, для перехода к следующему шагу чекаута
 * В `children` можно передать дополнительные компоненты, например, компонент с общими ошибками валидации
 */
export const TouristsFooterDesktop = (props: Props) => {
  const { isMobile, showPreloader, submit, btnDisabled, children } = props;

  if (isMobile) return null;

  return (
    <section>
      <h2 className="like-h2">{i18n.t('checkout.touristForm.title')}</h2>

      {children}

      <SubmitButton
        onClick={submit}
        size="large"
        primary
        disabled={btnDisabled}
        data-at-package-goto-payment
      >
        {showPreloader ? <Throbber /> : i18n.t('checkout.touristForm.next')}
      </SubmitButton>
    </section>
  );
};

const SubmitButton = styled(Button)`
  margin-top: 5px;
  width: 170px;
  height: 48px;
  font-size: 14px;
`;

const Throbber = styled(Spinner)`
  display: inline-block;
`;
